module.exports = __webpack_public_path__ + "img/rang_bg.cc938a4f.png";